// this file use the same naming pattern as `types/all`
// since `constants` is a reserved path on `node`

import { ThemeType } from 'app/types/all';

export const IS_DEV = process.env.NODE_ENV === 'development';

export const IS_DEMO_SITE = () =>
  IS_DEV ||
  (typeof window !== 'undefined' &&
    window.origin === 'https://echo.elys.network') ||
  (typeof window !== 'undefined' &&
    window.origin === 'https://devnet.elys.network');

export const DEFAULT_THEME: ThemeType = 'dark';

export const CONTACT_EMAIL = 'team@elys.network';

export const TERMS_LINK = 'https://elys.network/terms';

export const PRIVACY_LINK = 'https://elys.network/privacy';

export const GOVERNANCE_LINK = 'https://testnet.ping.pub/elys/gov';

export const DOCS_LINK = 'https://elys-network.gitbook.io/';

export const FEEDBACK_URL = 'https://tally.so/r/wAv0Qy';

export const SWAP_SLIPPAGE_PERCENTAGE = 0.01;
